import { gql } from 'graphql-request'

const GET_GROUP_HIGHEST_PRICE = gql`
  query getProductsHighestPrice(
    $slug: String
    $type: [String!]
    $topic: [bigint!]
    $product_categories: [bigint!]
    $creator_categories: [bigint!]
    $collections: [bigint!]
    $price_from: Int
    $price_to: Int
  ) {
    prices(
      limit: 1
      order_by: { price_subunit: desc }
      where: {
        product: {
          _and: [
            {
              product_group_connections: {
                product_group: { slug: { _ilike: $slug } }
              }
            }
            { type: { _in: $type } }
            { status: { _eq: "active" } }
            { visible: { _eq: "true" } }
            {
              product_categories: {
                _and: [
                  { product_category_id: { _in: $topic } }
                  { product_category_id: { _in: $product_categories } }
                ]
              }
            }
            { creator: { creator_category_id: { _in: $creator_categories } } }
            { _not: { type: { _eq: "Product::FansiForBrands" } } }
          ]
        }
        _or: [
          {
            product: {
              product_group_connections: {
                product_group: { slug: { _ilike: $slug } }
              }
            }
          }
          {
            price_contest_entry: {
              product: {
                product_group_connections: {
                  product_group: { slug: { _ilike: $slug } }
                }
              }
            }
          }
        ]
      }
    ) {
      value: price_subunit
    }

    total: product_group_connections_aggregate(
      where: {
        product_group: { slug: { _ilike: $slug } }
        product: {
          _and: [
            {
              product_group_connections: {
                product_group: { slug: { _ilike: $slug } }
              }
            }
            { type: { _in: $type } }
            { status: { _eq: "active" } }
            {
              _or: [
                {
                  product_contest_entries: {
                    price: {
                      price_subunit: { _gte: $price_from, _lte: $price_to }
                    }
                  }
                }
                {
                  price: {
                    price_subunit: { _gte: $price_from, _lte: $price_to }
                  }
                }
              ]
            }
            {
              product_categories: {
                _and: [
                  { product_category_id: { _in: $topic } }
                  { product_category_id: { _in: $product_categories } }
                ]
              }
            }
            { creator: { creator_category_id: { _in: $creator_categories } } }
            { _not: { type: { _eq: "Product::FansiForBrands" } } }
          ]
        }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`

export default GET_GROUP_HIGHEST_PRICE
